import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useState, useEffect } from 'react';
import Spacer from '../../structure/Spacer/Spacer';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CONSENT_IDENTIFIER = 'contentConsent:';
const ContentConsentManager = () => {
  const {
    0: consents,
    1: setConsents
  } = useState([]);
  const loadAndSetConsentsFromLocalStorage = async () => {
    if (typeof window !== 'undefined') {
      const items = _objectSpread({}, window.localStorage);
      const consents = [];
      await Object.keys(items).forEach(item => {
        if (item.startsWith(CONSENT_IDENTIFIER)) {
          consents.push(item);
        }
      });
      await setConsents(consents);
    }
  };
  useEffect(() => {
    loadAndSetConsentsFromLocalStorage();
  }, []);
  const handleCheckboxClicked = async consent => {
    // const lconsents = consents;
    // delete lconsents[consents.findIndex(c => c === consent)];
    // await setConsents(lconsents);
    window.localStorage.removeItem(consent);
  };
  if (consents.length === 0) {
    return null;
  }
  return ___EmotionJSX("div", null, ___EmotionJSX(Spacer, null), ___EmotionJSX("h1", null, "Zustimmungen verwalten"), ___EmotionJSX("h2", null, "Externe Inhalte"), ___EmotionJSX("ul", null, consents.map(consent => ___EmotionJSX("li", {
    key: consent
  }, ___EmotionJSX("input", {
    type: "checkbox",
    id: consent,
    onClick: () => handleCheckboxClicked(consent),
    defaultChecked: true
  }), ___EmotionJSX("label", {
    htmlFor: consent
  }, consent.slice(CONSENT_IDENTIFIER.length, consent.length))))), ___EmotionJSX(Spacer, null), ___EmotionJSX("h2", null, "Matomo Tracking"), ___EmotionJSX("iframe", {
    style: {
      border: 'none',
      width: '100%'
    },
    title: "Matomo Consent",
    src: "https://matomo.interness.de/index.php?module=CoreAdminHome&action=optOut&language=de&backgroundColor=&fontColor=&fontSize=&fontFamily=Open%20Sans"
  }));
};
export default ContentConsentManager;